import { ISelectedAnalys } from '../../EkonomiskAnalysPage';
import FunctionMenu from '../../../../../_Common/Components/FunctionMenu/FunctionMenu/FunctionMenu';
import FunctionItem from '../../../../../_Common/Components/FunctionMenu/FunctionItem/FunctionItem';

interface IProps {
  selectedAnalys: ISelectedAnalys;
  isLopandeAnalys?: boolean;
  showExcelModal?: () => void;
  showChartModal?: () => void;
  togglePDFModal: () => void;
  isChanges: boolean;
}

/**
 * Trepunktersmeny med ytterligare funktioner tillgängliga till en analys
 */
const EkonomiskAnalysHeaderFunctionButton = (props: IProps) => {
  const disabledReason = 'Analysen behöver uppdateras';

  return (
    <FunctionMenu id="ekonomiskAnalys">
      <FunctionItem
        disabled={props.isChanges}
        disabledReason={disabledReason}
        onClick={props.showExcelModal}
        iconType="excel_export"
      >
        Exportera till Excel
      </FunctionItem>
      <FunctionItem
        disabled={props.isChanges}
        disabledReason={disabledReason}
        onClick={props.togglePDFModal}
        iconType="print"
      >
        Skriv ut analys
      </FunctionItem>
      {props.showChartModal && (
        <FunctionItem
          onClick={props.showChartModal}
          disabled={!props.isLopandeAnalys || props.isChanges}
          disabledReason={
            !props.isLopandeAnalys
              ? 'Endast löpande analyser kan visas som graf'
              : props.isChanges
              ? disabledReason
              : undefined
          }
          iconType="bar_chart"
        >
          Visa som graf
        </FunctionItem>
      )}
    </FunctionMenu>
  );
};

export default EkonomiskAnalysHeaderFunctionButton;
